import { ComponentType } from '../../types';
import type { Component } from '../../types';

export function enhanceComponentsWithChildren(
  components: Component[],
): Component[] {
  const componentMap = new Map<string, Component>(
    components.map((component) => [component.id, component]),
  );

  const enhanceComponent = (component: Component): Component => {
    const isContainer =
      component.type === ComponentType.FLEX_CONTAINER ||
      component.type === ComponentType.CONTAINER ||
      component.type === ComponentType.CARD ||
      component.type === ComponentType.FORM_CONTAINER;

    if (isContainer && component.children?.length > 0) {
      const childComponents = component.children
        .map((childId) => componentMap.get(childId))
        .filter((child): child is Component => child !== undefined)
        .map((child) => enhanceComponent(child));

      return {
        ...component,
        _childComponents: childComponents,
      };
    }

    return component;
  };

  return components.map((component) => enhanceComponent(component));
}
